import {SponsorFormItemProps} from './type';
import {SpanIcon} from '@mazraeapp/react_icon_kit';
import FormItemValue from './FormItemValue';

const SponsorFormItem = ({
  title,
  isRequired,
  isShowArrowIcon,
  arrowHandler,
  isDisable,
  value,
  removeValue,
  isShowError,
  error,
  children,
}: SponsorFormItemProps) => {
  return (
    <div className="flex flex-col items-start gap-[16px] py-3 px-8 border-b border-gray-200">
      <div
        className="w-full flex items-center justify-between "
        onClick={() => (isDisable ? null : arrowHandler && arrowHandler())}
      >
        <p className="flex items-start mb-0 gap-1 text-md">
          <span className={`${isDisable ? 'text-gray-400' : ''}`}>{title}</span>
          {isRequired && (
            <span className={`${isDisable ? 'text-gray-400' : 'text-red-600'}`}>
              *
            </span>
          )}
        </p>
        {isShowArrowIcon && (
          <SpanIcon
            className={`icon-nameArrow---Left-2 text-[20px] ${
              isDisable ? 'text-gray-400' : 'text-gray-700'
            } `}
          />
        )}
      </div>
      {children}
      {Array.isArray(value) ? (
        <div className="flex flex-wrap gap-2">
          {value.length
            ? value.map((item, index) => (
                <FormItemValue
                  key={'sponser-form-item-value' + index}
                  valueType={'array'}
                  isDisable={isDisable}
                  value={item}
                  removeValue={removeValue as (item?: number) => void}
                />
              ))
            : null}
        </div>
      ) : value?.title ? (
        <FormItemValue
          valueType={'string'}
          isDisable={isDisable}
          value={value}
          removeValue={removeValue as (item?: number) => void}
        />
      ) : null}
      {isShowError ? (
        <p className="mb-0 text-red-600 text-sm font-normal">
          <SpanIcon className="icon-namereport-2 text-base align-middle inline-block ml-1" />
          <span>{error}</span>
        </p>
      ) : null}
    </div>
  );
};

export default SponsorFormItem;
